const Home = () => import('../pages/home').then(m => m.default || m)

const Settings = () => import('../pages/settings/index').then(m => m.default || m)
const SettingsProfile = () => import('../pages/settings/profile').then(m => m.default || m)

const ContentIndex = () => import('../pages/contents/index').then(m => m.default || m)
const ContentShow = () => import('../pages/contents/show').then(m => m.default || m)
const ContentResults = () => import('../pages/contents/results').then(m => m.default || m)

const TEC = () => import('../pages/tec/index').then(m => m.default || m)
const Contacto = () => import('../pages/contact/index').then(m => m.default || m)






export default [
    { path: '/', name: 'home', component: Home },
    { path: '/contents/:slug', name: 'home.category', component: ContentIndex },
    { path: '/content/:slug', name: 'content.show', component: ContentShow },

    { path: '/sports/', name: 'sports.index', component: ContentIndex },
    { path: '/contents/search/:query', name: 'contents.search', component: ContentResults },

    {path: '/pages/tec', name: 'tec', component: TEC},
    {path: '/pages/contact', name: 'contact', component: Contacto},

    { path: '*', name: '404', component: require('../pages/errors/404.vue') },
    { path: '/waiting', name: 'waiting', component: require('../pages/errors/waiting.vue') },
]



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js